module.exports = __webpack_public_path__ + "static/media/close-black.443c2881.svg";